import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import useCallApi from "../../hooks/useCallApi";
import TenantCommunityInboxApi, {
  IPost,
  IStatusCodes,
} from "../../api/tenantCommunityInboxPost";
import { Routes } from "../../routes/Routes";
import { useAlert } from "../../context/AlertContext";
import { useFormik } from "formik";
import tenantCommunityInboxPostValidations from "../../validations/tenantCommunityInboxPost";
import { useContent } from "../../content/useContent";
import { useRTL } from "../../hooks/useLanguage/useRTL";
import EventApi from "../../api/event";

const useTenantCommunityInboxPostContainer = (
  id?: string,
  isEdit: boolean = false
) => {
  const navigate = useNavigate();
  const { schema, pages, general } = useContent();
  const { tenantCommunityInbox } = pages;
  const { callApi, loading } = useCallApi();
  const { setSuccessMessage } = useAlert();
  const { isRTL } = useRTL();

  const [pageLoading, setPageLoading] = useState(true);
  // const [initialValues, setInitialValues] = useState<IPost["status"]["id"]>({
  const [initialValues, setInitialValues] = useState<any>({
    title: "",
    message: "",
    status: IStatusCodes.Pending,
    publishedAt: null
  });
  const [postImage, setPostImage] = useState<any>([]);
  const [selected, setSelected] = useState<any>(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  // useEffect(() => {
  //   setPageLoading(false);
  // }, [isRTL]);

  useEffect(() => {
    if (id) {
      setPageLoading(true);
      // const API = isEdit
      //   ? TenantCommunityInboxApi.getOneBoth(id)
      //   : TenantCommunityInboxApi.getOne(id);
      const API = TenantCommunityInboxApi.getAll();

      callApi(API, (inbox: IPost[]) => {
        const inboxPost = inbox.find((post) => post.id === id);
        if (inboxPost) {
          setInitialValues({ ...inboxPost, status: inboxPost.status.id, publishedAt: inboxPost.publishedAt });
          setPostImage(inboxPost.images);
        }

        setPageLoading(false);
      });
    } else {
      setPageLoading(false);
    }
  }, [id, isRTL]);

  const handleSubmit = (values: any) => {
    let body = { ...values };
    body.images = postImage.map((image: any) => {
      return { url: image.url, thumbnail: image.thumbnail };
    });

    delete body.id;
    delete body.createdAt;
    delete body.updatedAt;

    const API = isEdit
      ? TenantCommunityInboxApi.update(id, body)
      : TenantCommunityInboxApi.create(body);

    callApi(API, (result: any) => {
      setTimeout(
        () =>
          setSuccessMessage(
            isEdit
              ? tenantCommunityInbox.updateTenantCommunityInboxPost
              : tenantCommunityInbox.createTenantCommunityInboxPost
          ),
        1000
      );
      navigate(Routes.tenantCommunityInbox);
    });
  };

  const handleEdit = (id: string) => {
    navigate(Routes.getEditTenantCommunityInboxPost(id));
  };

  const tenantCommunityInboxPostFormik: any = useFormik({
    enableReinitialize: true,
    initialValues,
    // validationSchema: () => tenantCommunityInboxPostValidations(schema),
    onSubmit: (values: any) => handleSubmit(values),
  });

  const handleAttachment = (event: any) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("images", file);
    callApi(TenantCommunityInboxApi.upload(formData), async (data: any) => {
      setSuccessMessage(general.uploadImages);
      setPostImage([...postImage, ...data]);
    });
  }

  const handleDeleteImage = () => {
    callApi(
        TenantCommunityInboxApi.deleteImageSource({ url: selected.url }),
        async (data: any) => {
          setSuccessMessage(general.deleteImage);
          setPostImage(postImage.filter((image: any) => image.url !== selected.url))
          setSelected(null);
          setOpenDeleteDialog(false);
        }
    );
  }

  const handleOpenDeleteImage = (image: any) => {
    setOpenDeleteDialog(true);
    setSelected(image);
  };

  return {
    pageLoading,
    tenantCommunityInboxPostFormik,
    loading,
    handleEdit,
    postImage,
    handleAttachment,
    handleOpenDeleteImage,
    handleDeleteImage,
    openDeleteDialog,
    setOpenDeleteDialog
  };
};

export default useTenantCommunityInboxPostContainer;
